<template>
  <div class="activity">
    <div class="detailsTitle">
      <div class="detailsWrap"></div>
      <p>活動</p>
    </div>

    <el-form>
      <el-form-item label="活動名稱:">
        <input
          maxlength="100"
          class="el-input__inner"
          type="text"
          v-model="activity.applyName"
        />
      </el-form-item>

      <el-form-item label="活動類型:" v-if="type === 'edit'">
        <el-select
          v-model="activity.applyWay"
          disabled
          placeholder="請選擇活動類別"
        >
          <el-option label="一般活動" value="1"></el-option>
          <el-option label="演唱會" value="2"></el-option>
          <el-option label="見面會" value="4"></el-option>
          <el-option label="後臺活動" value="3"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item v-else label="活動類型:">
        <el-select
          v-model="activity.applyWay"
          @change="changeSelectValue"
          placeholder="請選擇活動類別"
        >
          <el-option label="一般活動" value="1"></el-option>
          <el-option label="演唱會" value="2"></el-option>
          <el-option label="見面會" value="4"></el-option>
          <el-option label="後臺活動" value="3"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="推送:">
        <el-switch
          :disabled="type == 'edit' && isopen == 0"
          active-color="#6C3DEA"
          v-model="popMesFlag"
        >
        </el-switch>
      </el-form-item>

      <el-form-item
        label="開放報名時間:"
        v-if="type === 'add' || isopen == 1 || type === 'draft'"
      >
        <el-date-picker
          v-model="activity.startTime"
          type="datetime"
          placeholder="选择时间"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="開放報名時間:" v-else>
        <el-date-picker
          v-model="activity.startTime"
          type="datetime"
          disabled
          placeholder="选择时间"
        >
        </el-date-picker>
      </el-form-item>

      <el-form-item
        label="結束報名時間:"
        v-if="type === 'add' || isopen == 1 || type === 'draft'"
      >
        <el-date-picker
          v-model="activity.endTime"
          type="datetime"
          placeholder="选择时间"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="結束報名時間:" v-else>
        <el-date-picker
          v-model="activity.endTime"
          type="datetime"
          disabled
          placeholder="选择时间"
        >
        </el-date-picker>
      </el-form-item>

      <el-form-item label="上傳列表主圖:" class="picupload">
        <el-upload
          action=""
          :http-request="uploadRequest"
          :headers="{ Authorization: this.$cookie.get('auth') }"
          :with-credentials="true"
          :on-remove="listVerticalHandleRemove"
          :on-error="$errorImage"
          :file-list="listVertical"
          :on-exceed="$handleExceed.bind(this, 1)"
          :on-change="handleChange"
          :before-upload="$beforePicUpload.bind(this, 2, 20)"
          :limit="1"
          accept=".jpg,.jpeg,.png"
          :multiple="false"
          name="listVertical"
          list-type="picture-card"
        >
          <el-button size="small" type="primary">選擇圖片</el-button>
          <div slot="tip" class="el-upload__tip">支持jpg/png格式(豎圖格式)</div>
        </el-upload>
      </el-form-item>

      <el-form-item label="活動詳情主圖:" class="picupload">
        <el-upload
          action=""
          :http-request="uploadRequest"
          :headers="{ Authorization: this.$cookie.get('auth') }"
          :with-credentials="true"
          :on-remove="activityVerticalHandleRemove"
          :on-error="$errorImage"
          :file-list="detailsVerticalList"
          :on-change="handleChange"
          :before-upload="$beforePicUpload.bind(this, 1, 20)"
          :limit="1"
          accept=".jpg,.jpeg,.png"
          :multiple="false"
          name="activityHorizontal"
          list-type="picture-card"
        >
          <el-button size="small" type="primary">選擇圖片</el-button>
          <div slot="tip" class="el-upload__tip">支持jpg/png格式(橫圖格式)</div>
        </el-upload>
      </el-form-item>
      <el-form-item label="收費活動:">
        <el-switch
          active-color="#6C3DEA"
          v-model="isChargeable"
          :disabled="type === 'edit'"
        >
        </el-switch>
      </el-form-item>
      <el-form-item label="活動地點:" v-if="isChargeable">
        <el-select v-model="activity.land" :disabled="type === 'edit'">
          <el-option label="大陆" value="0"></el-option>
          <el-option label="非大陆" value="1"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="顯示價格文案:" v-if="!isChargeable">
        <el-input
          :disabled="type === 'edit'"
          v-model="activity.freeContent"
          type="text"
          maxlength="15"
        />
      </el-form-item>
      <el-form-item label="活動價格:" v-if="isChargeable">
        <el-input
          :disabled="type === 'edit'"
          class="fl"
          v-model="activity.minPrice"
          @change="validatePrices"
        >
          <template slot="prepend">人民幣</template>
        </el-input>
        <el-input
          :disabled="type === 'edit'"
          style="margin-top: 10px"
          class="fl"
          v-model="activity.twdPrice"
          @change="validatePrice"
        >
          <template slot="prepend">新台幣</template>
        </el-input>
        <!-- <el-input
          v-if="type === 'add' && !isChargeable"
          :disabled="true"
          class="fl"
          v-model="activity.minPrice"
        >
          <template slot="prepend">新台幣</template>
        </el-input>
        <el-input
          v-if="type === 'edit'"
          :disabled="true"
          class="fl"
          v-model="activity.minPrice"
        >
          <template slot="prepend">新台幣</template>
        </el-input> -->
      </el-form-item>

      <el-form-item label="活動名額數:">
        <el-input
          v-if="type === 'edit'"
          disabled
          v-model="activity.totalNum"
          type="text"
        />
        <el-input
          v-else
          v-model="activity.totalNum"
          @change="validateInput"
          type="text"
        />
      </el-form-item>

      <el-form-item label="人数限制:">
        <div>
          <el-select
            v-model="numMin"
            @change="changeActivityNum('min')"
            :disabled="type === 'edit'"
          >
            <el-option label="1" value="1"></el-option>
            <el-option v-if="numMax !== '1'" label="2" value="2"></el-option>
          </el-select>
          &nbsp;&nbsp;~&nbsp;&nbsp;
          <el-select
            v-model="numMax"
            @change="changeActivityNum('max')"
            :disabled="type === 'edit'"
          >
            <el-option v-if="numMin !== '2'" label="1" value="1"></el-option>
            <el-option label="2" value="2"></el-option>
          </el-select>
        </div>
      </el-form-item>

      <el-form-item label="备注:">
        <el-switch
          active-color="#6C3DEA"
          v-model="needRemark"
          :disabled="type === 'edit'"
        >
        </el-switch>
      </el-form-item>

      <div class="editor-wrap">
        <p class="editor-title normal_font">圖文詳情:</p>
        <Editor @listenContent="getContent" :content="content"></Editor>
      </div>
    </el-form>

    <div class="bottomBtn">
      <div class="btn" @click="submitContent('push')">發佈</div>
      <div style="margin-left: 30px" v-if="type != 'edit'">
        <div
          class="btn"
          v-if="
            activity.applyName ||
            listVertical.length > 0 ||
            detailsVerticalList.length > 0 ||
            content
          "
          @click="submitContent('draft')"
        >
          保存爲草稿箱
        </div>
        <div class="btn" v-else style="background-color: #9999a1">
          保存爲草稿箱
        </div>
      </div>
    </div>

    <DiaMess v-if="dialogVisible"></DiaMess>
  </div>
</template>

<script>
import Editor from "@/components/editor";
import DiaMess from "@/components/dialog";

export default {
  props: ["type", "id", "isopen"],
  data() {
    return {
      activity: {
        applyName: "",
        applyWay: "", // 活動類型
        startTime: "",
        endTime: "",
        minPrice: "",
        totalNum: "",
        freeContent: "",
        land: "",
        twdPrice: "",
        // activityType: 1 //活動類別(VIP)
      },
      popMesFlag: false,
      // listHorizontal: [], // 活动列表主图横图
      listVertical: [],
      // detailsHorizontalList:[],// 活动详情主图
      detailsVerticalList: [],
      content: "", // 图文详情
      activityTips: false,
      activityTipsSucc: false,
      activityTipsError: false,
      activityTitle: "",
      dialogVisible: false,
      needRemark: false,
      numMin: "",
      numMax: "",
      isChargeable: false, //收费活动
    };
  },
  created() {
    let _this = this;
    if (_this.type === "edit" || _this.type === "draft") {
      _this.getActivityDetails();
    } else {
      _this.activity.minPrice = "0.00";
      _this.activity.twdPrice = "0.00";
    }
  },
  destroyed() {
    this.$message.closeAll();
  },
  methods: {
    changeActivityNum(val) {
      if (this.numMin === "2" && this.numMax === "1") this.numMin = "1";
    },
    // 获取编辑活动的活动详情
    getActivityDetails() {
      let _this = this;
      _this
        .$get(
          `/request/apply/getApplyDetail/${_this.id}`,
          _this.$GLOBAL.jsonConfig
        )
        .then((res) => {
          if (res.code === "00000") {
            _this.activity = {
              applyName: res.data.applyName,
              applyWay: res.data.applyWay,
              startTime: res.data.startTime
                ? new Date(res.data.startTime)
                : null,
              endTime: res.data.endTime ? new Date(res.data.endTime) : null,
              minPrice: res.data.minPrice,
              twdPrice: res.data.twdPrice,
              land:
                res.data.land === 0 || res.data.land === 1
                  ? res.data.land.toString()
                  : null,
              freeContent: res.data.freeContent,
              totalNum: res.data.totalNum,
              // activityType: res.data.type
            };
            this.numMin = res.data.numMin;
            this.numMax = res.data.numMax;
            this.isChargeable = res.data.free === 1 ? true : false;
            this.popMesFlag = res.data.pushFlag == 1 ? true : false;
            if (res.data.explain.length === 0) {
              _this.content = "";
            } else {
              _this.content = res.data.explain[0].explainValue;
            }

            // 列表主图
            if (res.data.showVenue) {
              if (res.data.showVenue.indexOf("☭") != -1) {
                _this.listVertical.push({
                  name: "img.jpg",
                  url: res.data.showVenue.split("☭")[1],
                });

                document.getElementsByClassName("el-upload")[0].style.display =
                  "none";
              } else {
                _this.listVertical.push({
                  name: "img.jpg",
                  url: res.data.showVenue,
                });
                document.getElementsByClassName("el-upload")[0].style.display =
                  "none";
              }
            }

            //活动主图
            if (res.data.showBanner) {
              if (res.data.showBanner.indexOf("☭") != -1) {
                _this.detailsVerticalList.push({
                  name: "img.jpg",
                  url: res.data.showBanner.split("☭")[1],
                });

                document.getElementsByClassName("el-upload")[1].style.display =
                  "none";
              } else {
                _this.detailsVerticalList.push({
                  name: "img.jpg",
                  url: res.data.showBanner,
                });
                document.getElementsByClassName("el-upload")[1].style.display =
                  "none";
              }
            }
            this.needRemark = res.data.needRemark === 1;
          } else {
            _this.$propMessage(res.message, "error");
          }
        });
    },

    // 上传图片
    uploadRequest(option) {
      const file = option.file;
      const self = this;
      return new Promise((resolve, reject) => {
        const date = self.$dateFormat(new Date(), "yyyy-MM-dd"); // 当前时间
        const dateTime = self.$dateFormat(new Date(), "yyyyMMddhhmmss"); // 当前时间
        let randomStr = self.$randomString(4); //  4位随机字符串
        const extensionName = file.name.substr(file.name.indexOf(".")); // 文件扩展名
        const fileWay = "resource/image/";
        const fileName =
          fileWay + date + "/" + dateTime + "_" + randomStr + extensionName; // 文件名字（相对于根目录的路径 + 文件名）
        // 执行上传
        self.$createOssClient().then((client) => {
          // 异步上传,返回数据
          // resolve({
          //   fileName: file.name,
          //   fileUrl: fileName // 图片路径
          // })
          // 上传处理
          // 分片上传文件
          client
            .multipartUpload(fileName, file, {
              headers: { "Cache-Control": "public" },
            })
            .then(
              (val) => {
                if (val.res.statusCode === 200) {
                  if (option.filename === "listVertical") {
                    // 列表主图竖图
                    self.listVertical.push({
                      url: self.$GLOBAL.picFileUrl + val.name,
                    }); // 展示图片
                    //cdn预热
                    self.$cdnFun(self.listVertical[0].url).then((res) => {
                      console.log(res);
                    });
                    document.getElementsByClassName(
                      "el-upload"
                    )[0].style.display = "none";
                  } else if (option.filename === "activityHorizontal") {
                    // 活动详情主图横图
                    self.detailsVerticalList.push({
                      url: self.$GLOBAL.picFileUrl + val.name,
                    }); // 展示图片
                    //cdn预热
                    self
                      .$cdnFun(self.detailsVerticalList[0].url)
                      .then((res) => {
                        console.log(res);
                      });
                    document.getElementsByClassName(
                      "el-upload"
                    )[1].style.display = "none";
                  }
                  return val;
                } else {
                  option.onError("上传失败1");
                }
              },
              (err) => {
                console.log(err);
                option.onError("上传失败");
                reject(err);
              }
            );
        });
      });
    },

    // 主图竖图
    listVerticalHandleRemove(file, fileList) {
      let _this = this;
      _this.$deleteUidItem(file.uid, _this.listVertical);
      document.getElementsByClassName("el-upload")[0].style.display =
        "inline-block";
    },
    validateInput() {
      let _this = this;
      _this.activity.totalNum = _this.activity.totalNum.replace(/\D/g, "");
      if (parseInt(_this.activity.totalNum) > 100000) {
        _this.dialogVisible = true;
        _this.$propMessage("活動名額數不能大於100000", "error", function () {
          _this.dialogVisible = false;
          _this.activity.totalNum = "";
        });
      }
    },
    // 删除活动详情横图
    activityVerticalHandleRemove(file, fileList) {
      let _this = this;
      _this.$deleteUidItem(file.uid, _this.detailsVerticalList);
      document.getElementsByClassName("el-upload")[1].style.display =
        "inline-block";
    },
    // 图片列表发生变化
    handleChange(file, fileList) {
      if (fileList.length > 1) {
        fileList.splice(0, 1);
      }
    },

    // 实时获取图文详情
    getContent(data) {
      let _this = this;
      _this.content = data;
    },

    // 活动类型选择发生改变
    changeSelectValue(val) {
      let _this = this;
      _this.activity.applyWay = val;
      // _this.activity.applyWay === "2"
      //   ? (_this.activity.minPrice = "0.00")
      //   : (_this.activity.minPrice = "0.00");
    },
    validatePrice() {
      const regex = /^(?!^\.)(?!.*\.$)(\d+(\.\d+)?)?$/;
      if (!regex.test(this.activity.twdPrice)) {
        this.activity.twdPrice = "";
      }
      if (this.activity.twdPrice > 10000000) {
        this.$errorMessage("活動價格不能超過10,000,000");
        this.activity.twdPrice = "";
      }
    },
    validatePrices() {
      const regex = /^(?!^\.)(?!.*\.$)(\d+(\.\d+)?)?$/;
      if (!regex.test(this.activity.minPrice)) {
        this.activity.minPrice = "";
      }
      if (this.activity.minPrice > 10000000) {
        this.$errorMessage("活動價格不能超過10,000,000");
        this.activity.minPrice = "";
      }
    },
    // 提交内容
    submitContent(sort) {
      let _this = this;
      if (sort == "push") {
        if (
          _this.activity.applyName === "" ||
          _this.$getCaption(_this.activity.applyName)
        ) {
          _this.dialogVisible = true;
          _this.$propMessage(
            "活動名稱不能為空或者含有非法字符",
            "error",
            function () {
              _this.dialogVisible = false;
            }
          );

          return false;
        }
        if (
          _this.activity.applyWay === "" ||
          _this.activity.applyWay === null
        ) {
          _this.dialogVisible = true;
          _this.$propMessage("活動類型不能為空", "error", function () {
            _this.dialogVisible = false;
          });
          return false;
        }
        if (_this.activity.applyName === "") {
          _this.dialogVisible = true;
          _this.$propMessage("活動名稱不能為空", "error", function () {
            _this.dialogVisible = false;
          });
          return false;
        }

        // 添加活动
        if (_this.type === "add" || _this.isopen === 1) {
          let timeFormat = _this.$compareTime(
            _this.activity.startTime,
            new Date()
          );
          if (_this.activity.startTime === null || timeFormat === false) {
            _this.dialogVisible = true;
            _this.$propMessage(
              "開始報名時間不能為空，且只能設置未來時間",
              "error",
              function () {
                _this.dialogVisible = false;
              }
            );

            return false;
          }

          let endtimeFormat = _this.$compareTime(
            _this.activity.endTime,
            _this.activity.startTime
          );
          if (_this.activity.endTime === null || endtimeFormat === false) {
            _this.dialogVisible = true;
            _this.$propMessage(
              "結束報名時間不能為空，且只能晚於開始報名時間",
              "error",
              function () {
                _this.dialogVisible = false;
              }
            );
            return false;
          }
        }

        if (_this.listVertical.length === 0) {
          _this.dialogVisible = true;
          _this.$propMessage("列表主圖竖图格式不能為空", "error", function () {
            _this.dialogVisible = false;
          });
          return false;
        }

        if (_this.detailsVerticalList.length === 0) {
          _this.dialogVisible = true;
          _this.$propMessage("活動詳情主圖横图不能為空", "error", function () {
            _this.dialogVisible = false;
          });
          return false;
        }
        if (!_this.isChargeable) {
          if (
            _this.activity.freeContent == "" ||
            _this.activity.freeContent == null
          ) {
            _this.dialogVisible = true;
            _this.$propMessage("顯示價格文案不能為空", "error", function () {
              _this.dialogVisible = false;
            });
            return false;
          }
        } else {
          if (_this.activity.land == "" || _this.activity.land == null) {
            _this.dialogVisible = true;
            _this.$propMessage("活動地點不能為空", "error", function () {
              _this.dialogVisible = false;
            });
            return false;
          }
          if (
            _this.activity.minPrice === "" ||
            _this.activity.minPrice === null
          ) {
            _this.dialogVisible = true;
            _this.$propMessage("人民幣價格不能為空", "error", function () {
              _this.dialogVisible = false;
            });
            return false;
          }
          if (
            _this.activity.twdPrice === "" ||
            _this.activity.twdPrice === null
          ) {
            _this.dialogVisible = true;
            _this.$propMessage("新台幣價格不能為空", "error", function () {
              _this.dialogVisible = false;
            });
            return false;
          }
        }
        if (
          _this.activity.totalNum === "" ||
          _this.activity.totalNum === null
        ) {
          _this.dialogVisible = true;
          _this.$propMessage("活動名額數不能為空", "error", function () {
            _this.dialogVisible = false;
          });
          return false;
        }

        if (
          _this.numMin === "" ||
          this.numMax === "" ||
          _this.numMax === null ||
          _this.numMin === null
        ) {
          _this.dialogVisible = true;
          _this.$propMessage("人數限制不能為空", "error", function () {
            _this.dialogVisible = false;
          });

          return false;
        }

        if (_this.content === "" || _this.content === null) {
          _this.dialogVisible = true;
          _this.$propMessage("圖文詳情不能為空", "error", function () {
            _this.dialogVisible = false;
          });

          return false;
        }
      }
      // 增加活动提交
      if (_this.type === "add") {
        let param = {
          // type:_this.activity.activityType,
          applyName: _this.activity.applyName,
          applyWay: _this.activity.applyWay,
          applyNum: _this.activity.totalNum,
          endTime: _this.activity.endTime
            ? _this.$formatDate(_this.activity.endTime)
            : null,
          startTime: _this.activity.startTime
            ? _this.$formatDate(_this.activity.startTime)
            : null,
          showVenue:
            _this.listVertical.length > 0 ? _this.listVertical[0].url : null,
          detailsImg:
            _this.detailsVerticalList.length > 0
              ? _this.detailsVerticalList[0].url
              : null,
          explainValue: _this.content,
          jpushFlag: _this.popMesFlag ? 1 : 0,
          needRemark: this.needRemark ? 1 : 0,
          numMin: this.numMin,
          numMax: this.numMax,
          free: this.isChargeable ? 1 : 0,
        };
        // if (_this.activity.applyWay === "2") {
        //   param.minPrice = _this.activity.minPrice;
        // }
        if (_this.isChargeable) {
          param.minPrice = _this.activity.minPrice
            ? _this.activity.minPrice
            : null;
          param.twdPrice = _this.activity.twdPrice
            ? _this.activity.twdPrice
            : null;
          param.land = _this.activity.land;
        } else {
          param.freeContent = _this.activity.freeContent;
        }
        let url = "";
        if (sort === "push") {
          url = "/request/apply/saveApply";
        } else {
          url = "/request/apply/drafts/operation";
        }
        _this.$post(url, param, _this.$GLOBAL.jsonConfig).then((res) => {
          _this.dialogVisible = true;
          if (res.code === "00000") {
            _this.$propMessage(
              sort == "push" ? "新增活動成功" : "新增草稿成功",
              "success",
              function () {
                _this.dialogVisible = false;
                _this.$router.go(-1);
              }
            );
          } else {
            _this.$propMessage(res.message, "error", function () {
              _this.dialogVisible = false;
            });
          }
        });
      } else if (_this.type === "edit" || _this.type === "draft") {
        let editParam = {};
        if (_this.type === "edit") {
          if (_this.isopen == 1) {
            editParam = {
              id: _this.id,
              applyName: _this.activity.applyName,
              endTime: _this.activity.endTime
                ? _this.$formatDate(_this.activity.endTime)
                : null,
              startTime: _this.activity.startTime
                ? _this.$formatDate(_this.activity.startTime)
                : null,
              showVenue:
                _this.listVertical.length > 0
                  ? _this.listVertical[0].url
                  : null,
              detailsImg:
                _this.detailsVerticalList.length > 0
                  ? _this.detailsVerticalList[0].url
                  : null,
              explainValue: _this.content,
              needRemark: this.needRemark ? 1 : 0,
              numMin: this.numMin,
              numMax: this.numMax,
              free: this.isChargeable ? 1 : 0,
              jpushFlag: _this.popMesFlag ? 1 : 0,
            };
          } else {
            // 编辑活动提交
            editParam = {
              id: _this.id,
              applyName: _this.activity.applyName,
              showVenue:
                _this.listVertical.length > 0
                  ? _this.listVertical[0].url
                  : null,
              detailsImg:
                _this.detailsVerticalList.length > 0
                  ? _this.detailsVerticalList[0].url
                  : null,
              explainValue: _this.content,
              needRemark: this.needRemark ? 1 : 0,
              numMin: this.numMin,
              numMax: this.numMax,
              free: this.isChargeable ? 1 : 0,
            };
          }
        } else {
          editParam = {
            id: _this.id,
            applyName: _this.activity.applyName,
            applyWay: _this.activity.applyWay,
            applyNum: _this.activity.totalNum,
            endTime: _this.activity.endTime
              ? _this.$formatDate(_this.activity.endTime)
              : null,
            startTime: _this.activity.startTime
              ? _this.$formatDate(_this.activity.startTime)
              : null,
            showVenue:
              _this.listVertical.length > 0 ? _this.listVertical[0].url : null,
            detailsImg:
              _this.detailsVerticalList.length > 0
                ? _this.detailsVerticalList[0].url
                : null,
            explainValue: _this.content,
            needRemark: this.needRemark ? 1 : 0,
            numMin: this.numMin,
            numMax: this.numMax,
            free: this.isChargeable ? 1 : 0,
            jpushFlag: _this.popMesFlag ? 1 : 0,
          };
        }
        if (_this.isChargeable) {
          editParam.minPrice = _this.activity.minPrice
            ? _this.activity.minPrice
            : null;
          editParam.twdPrice = _this.activity.twdPrice
            ? _this.activity.twdPrice
            : null;
          editParam.land = _this.activity.land;
        } else {
          editParam.freeContent = _this.activity.freeContent;
        }
        let urls = "";
        if (sort === "draft") {
          urls = "/request/apply/drafts/operation";
        } else {
          urls = "/request/apply/updateApplyDetail";
        }
        _this.$post(urls, editParam, _this.$GLOBAL.jsonConfig).then((res) => {
          _this.dialogVisible = true;

          if (res.code === "00000") {
            _this.$propMessage(
              sort == "push" ? "編輯活動發佈成功" : "編輯草稿成功",
              "success",
              function () {
                _this.dialogVisible = false;
                _this.$router.go(-1);
              }
            );
          } else {
            _this.$propMessage(res.message, "error", function () {
              _this.dialogVisible = false;
              _this.$router.go(-1);
            });
          }
        });
      }
    },
  },
  components: {
    Editor,
    DiaMess,
  },
};
</script>



// WEBPACK FOOTER //
// src/components/activity.vue